import { render, staticRenderFns } from "./ReportDesktopGroupMeals.vue?vue&type=template&id=0280a981"
import script from "./ReportDesktopGroupMeals.vue?vue&type=script&lang=js"
export * from "./ReportDesktopGroupMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports